import { render } from "./form-soal-benar-salah.vue?vue&type=template&id=60162369&scoped=true"
import script from "./form-soal-benar-salah.vue?vue&type=script&lang=js"
export * from "./form-soal-benar-salah.vue?vue&type=script&lang=js"

import "./form-soal-benar-salah.vue?vue&type=style&index=0&id=60162369&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60162369"]])

export default __exports__